import config from "../config.js";
import Trace from "./snake.lib.trace.js";
import Url from "./snake.lib.url.js";
import { Swiper, Navigation } from "swiper";
import Hook from "./snake.lib.hook.js";
import AnalyticsService from "./snake.lib.analytics.js";
import Component from "../component.js";
import ApiService from "./snake.lib.api.js";
import Utils from "./snake.lib.utils.js";
import Storage from "./snake.lib.storage.js";

export default class Summary {
    static modalI18nGenericOptions;
    static #componentDom;
    static #testVersion;
    static #testId;

    static load = async () => {
        this.modalI18nGenericOptions = Component.getModalI18nGenericOptions();

        if (window.snakeCheckout.type === "subscription") {
            document.getElementById("_cmpSummaryItems").remove();
            this.#componentDom = document.getElementById("_cmpSummarySubscription");

            if (this.#componentDom) {
                //     this.#componentDom.classList.remove("hidden");

                this.#testVersion = Url.getParametes("testVersion");
                this.#testId = Url.getParametes("testId");

                if (this.#testVersion && (!this.#testId || this.#testId === "10052023" || this.#testId === "30102024")) this.#componentDom.classList.add("version-b");

                this.#renderCheckoutProductImage();

                this.#renderSummarySubscription();
            }
        } else if (window.snakeCheckout.type === "items") {
            if (document.getElementById("_cmpSummarySubscription")) document.getElementById("_cmpSummarySubscription").remove();

            this.#componentDom = document.getElementById("_cmpSummaryItems");

            if (this.#componentDom) {
                this.#componentDom.classList.remove("hidden");

                this.#renderSummaryItems();
            }
        }
    };

    static #handleMobileSummary = () => {
        document.getElementById("toggle-mobile-summary").addEventListener("click", () => {
            const bodyClasses = document.querySelector("body").classList;

            bodyClasses.toggle("open-drawer");

            AnalyticsService.summaryDrawerIsOpen(bodyClasses.contains("open-drawer"));
        });
    };

    static #renderSummaryItems = () => {
        Trace.debug("SUMMARY ITEMS");

        ApiService.getSummaryItems(window.snakeCheckout.initData.cart_id)
            .then((response) => {
                Trace.warn("getSummaryItems");
                Trace.print(response);

                if (response.data.banners) {
                    window.snakeCheckout.commerceBanners = response.data.banners;

                    Component.load(config.routing.sections.commerceBanner.component);
                }

                const itemsList = response.data.items_list ?? [];

                window.snakeCheckout.initData.items = {};

                window.snakeCheckout.initData.products = itemsList;
                Storage.set("init", JSON.stringify(window.snakeCheckout.initData));
                AnalyticsService.checkoutInitLoad();

                /**
                 * Save the itmes list on Local Storage to be able to use it on the Thank You page
                 */
                Storage.set("items", JSON.stringify(itemsList));

                itemsList.forEach((item) => {
                    ((window.snakeCheckout.initData.items ??= {}).refs ??= []).push({
                        item: item.sku,
                        quantity: item.quantity,
                    });
                });

                Trace.log("window.snakeCheckout.initData.items render");
                Trace.print(window.snakeCheckout.initData.items);

                /**
                 * Save currency format variables on Local Storage to be able to use them on the Thank You page
                 */
                Storage.set(
                    "currency",
                    JSON.stringify({
                        currencyIconPosition: response.data.currencyIconPosition ?? response.data.currency_icon_position ?? "after",
                        currencyDecimalDivider: response.data.currencyDecimalDivider ?? response.data.currency_decimal_divider ?? "comma",
                    })
                );

                this.#renderPrices(response.data ?? {});

                this.#renderItems(itemsList, response.data);

                this.#handleSummaryActions();

                this.#handleMobileSummary();
            })
            .catch((e) => {
                Utils.modal("popup", true, this.modalI18nGenericOptions);

                AnalyticsService.errorEvent("4_summary", "technical", "snakeAPI | summary get cart items error", e);
            });
    };

    static #renderPrices = (data) => {
        const pricesDom = this.#componentDom.querySelector("#prices");

        pricesDom.innerLoader(true);

        pricesDom.replaceChildren();
        pricesDom.appendChild(this.#componentDom.querySelector("template#tpl-prices").content.cloneNode(true));

        const itemsTotalPrice = data.items_amount ?? 0;
        Storage.set("price", itemsTotalPrice);

        pricesDom.querySelector("itemstotalprice").outerHTML = this.formatPrice(itemsTotalPrice, config.countries[window.snakeCheckout.currentCountry].currencySymbol, data.currencyIconPosition ?? data.currency_icon_position ?? "after", data.currencyDecimalDivider ?? data.currency_decimal_divider ?? "comma");

        const itemsShippinPrice = data.shipping_amount ?? 0;
        Storage.set("shipping", itemsShippinPrice);

        pricesDom.querySelector("itemsshippinprice").outerHTML = this.formatPrice(itemsShippinPrice, config.countries[window.snakeCheckout.currentCountry].currencySymbol, data.currencyIconPosition ?? data.currency_icon_position ?? "after", data.currencyDecimalDivider ?? data.currency_decimal_divider ?? "comma");

        // pricesDom.querySelector("itemsstaxes").outerHTML = this.formatPrice(data.taxes_amount ?? 0, config.countries[window.snakeCheckout.currentCountry].currencySymbol, data.currencyIconPosition ?? ( data.currency_icon_position ?? "after"), data.currencyDecimalDivider ?? (data.currency_decimal_divider ?? "comma"));

        pricesDom.querySelector("itemsstotalprice").outerHTML = this.formatPrice(data.total_amount ?? 0, config.countries[window.snakeCheckout.currentCountry].currencySymbol, data.currencyIconPosition ?? data.currency_icon_position ?? "after", data.currencyDecimalDivider ?? data.currency_decimal_divider ?? "comma");

        pricesDom.innerLoader(false);
        pricesDom.querySelector(":scope > div").classList.remove("hidden");

        document.querySelectorAll("itemsnumber").forEach((element) => {
            element.outerHTML = (data.items_count ?? 0).toString();
        });
    };

    static #renderItems = (items, data) => {
        const itemsDom = this.#componentDom.querySelector("#items");

        itemsDom.innerLoader(true);

        itemsDom.replaceChildren();

        items.forEach((item) => {
            itemsDom.appendChild(this.#componentDom.querySelector("template#tpl-item").content.cloneNode(true));

            const itemDom = itemsDom.lastElementChild;

            itemDom.dataset.sku = item.sku;

            itemDom.querySelector("img").src = item.image ?? "";
            itemDom.querySelector("itemtitle").outerHTML = item.name ?? "";

            if ((item.quantity ?? 0) > 1) itemDom.querySelector("itemquantity").outerHTML = "x " + item.quantity ?? 0;
            else itemDom.querySelector("itemquantity").parentElement.parentElement.parentElement.remove();

            // itemDom.querySelector("itemoriginalprice").outerHTML = this.formatPrice(item.price ?? 0, config.countries[window.snakeCheckout.currentCountry].currencySymbol, data.currencyIconPosition ?? data.currency_icon_position ?? "after", "comma");
            itemDom.querySelector("itemprice").outerHTML = this.formatPrice(item.price ?? 0, config.countries[window.snakeCheckout.currentCountry].currencySymbol, data.currencyIconPosition ?? data.currency_icon_position ?? "after", data.currencyDecimalDivider ?? data.currency_decimal_divider ?? "comma");
        });

        itemsDom.innerLoader(false);
    };

    static #handleSummaryActions = () => {
        Hook.subscribe("_setCart", async () => {
            Utils.spinner("loader", true);

            Trace.log("_setCart");
            Trace.print(window.snakeCheckout.initData.items);

            await ApiService.cartUpdate({
                store_code: (import.meta.env.CO_BRAND === "deagostini" ? "PW" : "FH") + window.snakeCheckout.currentCountry.toUpperCase(),
                cart_id: window.snakeCheckout.initData.cart_id,
                ...window.snakeCheckout.initData.items,
            })
                .then((response) => {
                    Trace.log("ApiService.cartUpdate");
                    Trace.log(response);

                    Trace.log(document.getElementById(config.routing.sections.payment.component).classList.contains("hidden"));

                    Summary.load();

                    // if (!document.getElementById(config.routing.sections.payment.component).classList.contains("hidden")) Component.load(config.routing.sections.payment.component);
                })
                .catch((e) => {
                    Utils.modal("popup", true, this.modalI18nGenericOptions);

                    AnalyticsService.errorEvent("4_summary", "technical", "snakeAPI | update cart error", e);
                });

            Utils.spinner("loader", false);
        });

        this.#componentDom.querySelectorAll("#items .increment").forEach((element) => {
            if (!element.dataset.events || !element.dataset.events.includes("click")) {
                element.addEventListener("click", (e) => {
                    this.#componentDom.querySelector('[data-hook="_setCart"]').classList.remove("hidden");

                    const currentItem = e.currentTarget.closest(".item");
                    const cart = window.snakeCheckout.initData.items;
                    const itemIndex = cart.refs.findIndex((item) => item.item === currentItem.dataset.sku);

                    currentItem.querySelector(".quantity").innerText = ++cart.refs[itemIndex].quantity;

                    Trace.log("window.snakeCheckout.initData.items increment");
                    Trace.print(window.snakeCheckout.initData.items);
                });

                element.dataset.events = "click";
            }
        });

        this.#componentDom.querySelectorAll("#items .decrement").forEach((element) => {
            if (!element.dataset.events || !element.dataset.events.includes("click")) {
                element.addEventListener("click", (e) => {
                    const currentItem = e.currentTarget.closest(".item");
                    const cart = window.snakeCheckout.initData.items;
                    const itemIndex = cart.refs.findIndex((item) => item.item === currentItem.dataset.sku);
                    const quantity = cart.refs[itemIndex].quantity;

                    if (quantity === 1) currentItem.querySelector("img.delete").click();
                    else {
                        cart.refs[itemIndex].quantity--;

                        currentItem.querySelector(".quantity").innerText = quantity - 1;
                        this.#componentDom.querySelector('[data-hook="_setCart"]').classList.remove("hidden");

                        Trace.log("window.snakeCheckout.initData.items decrement");
                        Trace.print(window.snakeCheckout.initData.items);
                    }
                });

                element.dataset.events = "click";
            }
        });

        this.#componentDom.querySelectorAll("#items img.delete").forEach((element) => {
            if (!element.dataset.events || !element.dataset.events.includes("click")) {
                element.addEventListener("click", (e) => {
                    const currentItem = e.currentTarget.closest(".item");

                    Utils.modal(
                        "dialog",
                        true,
                        { text: window.snakeCheckout.translations["summary.items.delete.text"], confirmBtn: window.snakeCheckout.translations["summary.items.delete.confirm"], dismissBtn: window.snakeCheckout.translations["summary.items.delete.dismiss"] },
                        () => {
                            this.#componentDom.querySelector('[data-hook="_setCart"]').classList.remove("hidden");

                            const cart = window.snakeCheckout.initData.items;
                            const itemIndex = cart.refs.findIndex((item) => item.item === currentItem.dataset.sku);

                            cart.refs.splice(itemIndex, 1);

                            Trace.log("window.snakeCheckout.initData.items delete");
                            Trace.print(window.snakeCheckout.initData.items);

                            currentItem.remove();

                            Utils.modal("dialog", false);
                        },
                        () => {
                            Utils.modal("dialog", false);
                        },
                        "bold"
                    );
                });

                element.dataset.events = "click";
            }
        });
    };

    static #renderSummarySubscription = () => {
        const product = window.snakeCheckout.initData.products[0];

        // const setPriceAndContinueLoadingCheckout = (price = 0) => {
        //     window.snakeCheckout.revenue = price;

        //     Hook.publish("_productRevenueValue", {
        //         detail: price,
        //     });
        // };

        fetch(import.meta.env.CO_SNAKE_API_CACHED.replace("-test", "-qa") + "/api/v1/core/integration/product-info?sku=" + product.sku + "&limit=4")
            .then((response) => response.json())
            .then((response) => {
                Trace.debug("Summary load product-info");
                Trace.log(response);

                window.snakeCheckout.termsAndConditionsUrl = response.data.termsAndConditionsUrl;

                this.#handleMobileSummary();

                if (response.data.checkoutPremiumBanner.showPremiumBanner && !response.data.isPremium) {
                    window.snakeCheckout.premiumSku = response.data.checkoutPremiumBanner.premiumSku;

                    Component.load(config.routing.sections.premiumBanner.component);
                }

                const offerTypes = {
                    ST: "Standard",
                    PR: window.snakeCheckout.currentCountry === "cz" ? "Prémium" : "Premium",
                };

                const imgTag = this.#componentDom.querySelector("#product-image");
                imgTag.alt = response.data.head.productImage.alt || "";
                imgTag.title = response.data.head.productImage.title || "";

                const offerTypeDom = this.#componentDom.querySelector("offertype");
                offerTypeDom.outerHTML = response.data.head.summaryTitle || offerTypes[product.edition] || "";

                this.#componentDom.querySelector("productlocaltitle").outerHTML = product.title;

                const noteIconDom = this.#componentDom.querySelector("#note-icon");
                if (response.data.head.summaryNoteIcon || response.data.head.summaryNoteTitle || response.data.head.summaryNoteText) {
                    noteIconDom.parentElement.classList.remove("hidden");

                    if (response.data.head.summaryNoteIcon) noteIconDom.src = response.data.head.summaryNoteIcon.src;
                    else noteIconDom.remove();

                    const noteTitleDom = this.#componentDom.querySelector("notetitle");
                    if (response.data.head.summaryNoteTitle) noteTitleDom.outerHTML = response.data.head.summaryNoteTitle;
                    else noteTitleDom.parentElement.remove();

                    const noteTextDom = this.#componentDom.querySelector("notetext");
                    if (response.data.head.summaryNoteText) noteTextDom.outerHTML = response.data.head.summaryNoteText;
                    else noteTextDom.parentElement.remove();
                } else noteIconDom.parentElement.remove();

                if (response.data.dispatches) {
                    this.#renderGifts(response.data);

                    const responseDataDispatches0IssuesLength = response.data.dispatches[0].issues.length;

                    response.data.dispatches.forEach((dispatch, dispatchIndex, array) => {
                        if (dispatch.issues) {
                            // FR-2434
                            const reducedVersion = this.getCountryConfigReducedVersion();
                            if (reducedVersion) {
                                if (dispatchIndex === 0) this.#renderDispatch(response.data, dispatch, dispatchIndex);
                            } else {
                                // if (dispatchIndex === 0) setPriceAndContinueLoadingCheckout(dispatch.totals.priceValue || 0);
                                if (dispatchIndex === 0 || (dispatchIndex < response.data.settings.summary_dispatch_number && response.data.dispatches.length > response.data.settings.summary_dispatch_number && (dispatch.isDiscounted || responseDataDispatches0IssuesLength !== dispatch.issues.length))) {
                                    dispatch.showNextShipmentNote = false;

                                    this.#renderDispatch(response.data, dispatch, dispatchIndex);
                                } else {
                                    dispatch.discountRibbon = false;

                                    dispatch.nextShipmentTitle = response.data.head.nextShipments.title !== "checkout.product-info.next-shipment.title" ? response.data.head.nextShipments.title : null;

                                    if (product.edition === "PR") {
                                        dispatch.subtitle.nextShipmentPremiumText = response.data.head.nextShipments.premiumText !== "checkout.product-info.next-shipment.premium-text" ? response.data.head.nextShipments.premiumText : "";
                                    }

                                    const firstIssue = dispatch.issues[0];

                                    firstIssue.nextShipmentIssueName = response.data.head.nextShipments.issue.name;
                                    firstIssue.nextShipmentSalesPromo = dispatch.subtitle.label || null;

                                    dispatch.issues = [];
                                    dispatch.issues.push(firstIssue);

                                    this.#renderDispatch(response.data, dispatch, dispatchIndex);

                                    array.length = dispatchIndex + 1; // break loop
                                }
                            }
                        }
                    });
                } else {
                    /**
                     * if the variant doesn't have any dispatches, we send the _productRevenueValue event anyway to allow the checkout to keep loading and don't block the customer just because the product price is missing
                     */
                    // setPriceAndContinueLoadingCheckout();
                    // AnalyticsService.errorEvent("0_init", "data", "snakeAPI | summary get product info missing dispatches");
                }

                if (response?.data?.settings?.show_shipping_estimation_date ?? false) window.snakeCheckout.shippingEstimationText = response?.data?.settings?.shipping_estimation_text ?? "";
                else delete window.snakeCheckout.shippingEstimationText;
            })
            .catch((e) => {
                /**
                 * if the product-info endpoint throws an error, we send the _productRevenueValue event anyway to allow the checkout to keep loading and don't block the customer
                 */
                // setPriceAndContinueLoadingCheckout();

                AnalyticsService.errorEvent("0_init", "technical", "snakeAPI | summary get product info error", e);
            });
    };

    static #renderDispatch = (responseData, dispatch, dispatchIndex) => {
        const product = window.snakeCheckout.initData.products[0];
        const dispatchesDom = this.#componentDom.querySelector("#dispatches");
        dispatchesDom.appendChild(this.#componentDom.querySelector("template#tpl-dispatch").content.cloneNode(true));

        const dispatchDom = dispatchesDom.lastElementChild;

        const dispatchTitleTag = dispatchDom.querySelector("dispatchtitle");

        const discountValueTag = dispatchDom.querySelector("dispatchdiscountvalue");
        if (dispatch.discountRibbon) {
            dispatchTitleTag.parentElement.classList.add("pl-[40px]");
            discountValueTag.outerHTML = dispatch.discount || 0;
        } else discountValueTag.parentElement.parentElement.remove();

        dispatchTitleTag.outerHTML = dispatch.nextShipmentTitle || dispatch.title || "";

        if (!dispatch.freeShipping) dispatchDom.querySelector(".free-shipping-label").remove();

        const dispatchSubtitleTextTag = dispatchDom.querySelector("dispatchsubtitletext");
        const dispatchDescriptionTag = dispatchDom.querySelector("dispatchdescription");
        if (dispatch.freeShipping) {
            dispatchSubtitleTextTag.parentElement.remove();
            dispatchDescriptionTag.parentElement.remove();
        } else {
            dispatchSubtitleTextTag.outerHTML = dispatch.subtitle.text || "";
            dispatchDescriptionTag.outerHTML = dispatch.subtitle.description || "";
        }

        const dispatchSubtitlePaymentDescriptionTag = dispatchDom.querySelector("dispatchsubtitlepaymentdescription");
        if (dispatch.subtitle.paymentDescription) dispatchSubtitlePaymentDescriptionTag.outerHTML = dispatch.subtitle.paymentDescription || "";
        else dispatchSubtitlePaymentDescriptionTag.parentElement.remove();

        const subtitleNextShipmentPremiumTextTag = dispatchDom.querySelector("dispatchsubtitlenextshipmentpremiumtext");
        if (dispatch.subtitle.nextShipmentPremiumText) subtitleNextShipmentPremiumTextTag.outerHTML = dispatch.subtitle.nextShipmentPremiumText || "";
        else subtitleNextShipmentPremiumTextTag.parentElement.remove();

        const dispatchNextShipmentNoteTag = dispatchDom.querySelector("dispatchnextshipmentnote");
        if (dispatch.showNextShipmentNote) dispatchNextShipmentNoteTag.outerHTML = dispatch.subtitle.nextShipmentNote || "";
        else dispatchNextShipmentNoteTag.parentElement.remove();

        if (responseData.groupIssueTitle) {
            dispatch.issues.sort((a, b) => a.sequence - b.sequence);

            dispatch.issues = dispatch.issues.reduce((group, issue) => {
                const key = (issue.originalPrice || 0).toString() + (issue.salesPrice || 0).toString();

                group[key] = group[key] ?? [];
                group[key].push(issue);
                return group;
            }, {});

            for (const key1 in dispatch.issues) {
                if (dispatch.issues[key1].length === 1) this.#renderIssue(responseData, dispatch, dispatchDom, dispatch.issues[key1][0]);
                else {
                    const regex = /\d+/;
                    let count = 0;
                    let numbers = "";

                    for (const key2 in dispatch.issues[key1]) {
                        const issueText = ["12", "FK"].includes(product.plan) ? dispatch.issues[key1][key2].description : dispatch.issues[key1][key2].name;

                        if (regex.test(issueText)) {
                            count++;
                            numbers += issueText.match(regex)[0] + ", ";
                        }
                    }

                    if (dispatch.issues[key1].length === count) {
                        if (["12", "FK"].includes(product.plan)) dispatch.issues[key1][0].description = dispatch.issues[key1][0].description.replace(regex, numbers.replace(/, +$/, ""));
                        else dispatch.issues[key1][0].name = dispatch.issues[key1][0].name.replace(regex, numbers.replace(/, +$/, ""));

                        this.#renderIssue(responseData, dispatch, dispatchDom, dispatch.issues[key1][0]);
                    } else {
                        for (const key3 in dispatch.issues[key1]) this.#renderIssue(responseData, dispatch, dispatchDom, dispatch.issues[key1][key3]);
                    }
                }
            }
        } else {
            dispatch.issues.forEach((issue) => {
                this.#renderIssue(responseData, dispatch, dispatchDom, issue);
            });
        }

        const taxesDom = dispatchDom.querySelector(".taxes");
        if (window.snakeCheckout.currentCountry === "us") {
            if (dispatchIndex !== 0) taxesDom.querySelector("span:nth-child(2)").remove();
            else taxesDom.querySelector("span:nth-child(3)").remove();

            taxesDom.classList.remove("hidden");

            Hook.subscribe("_commerceCreateAddresses", (e) => {
                Trace.debug("_commerceCreateAddresses");
                Trace.debug(e);

                taxesDom.querySelector("span:nth-child(2) span:nth-child(1)").classList.add("hidden");

                // taxesDom.querySelector("span:nth-child(2) span:nth-child(2) span").innerHTML = this.formatPrice(e.detail.data.cart.taxes[0].amount || 0, config.countries[window.snakeCheckout.currentCountry].currencySymbol, responseData.head.currencyIconPosition, responseData.head.currencyDecimalDivider);
                taxesDom.querySelector("span:nth-child(2) span:nth-child(2) span").innerHTML = this.formatPrice(0, config.countries[window.snakeCheckout.currentCountry].currencySymbol, responseData.head.currencyIconPosition, responseData.head.currencyDecimalDivider);

                taxesDom.querySelector("span:nth-child(2) span:nth-child(2)").classList.remove("hidden");
            });
        } else taxesDom.remove();

        if (window.snakeCheckout.currentCountry !== "us" && (!this.#testVersion || (this.#testId && this.#testId !== "10052023" && this.#testId !== "30102024"))) {
            dispatchDom.querySelector(".totals").remove();
        } else if (!this.#testVersion || (this.#testId && this.#testId !== "10052023" && this.#testId !== "30102024")) {
            dispatchDom.querySelector(".totals").remove();
        } else {
            const totalsTaxesLabelTag = dispatchDom.querySelector(".totalstaxeslabel");
            if (window.snakeCheckout.currentCountry === "us") totalsTaxesLabelTag.classList.remove("hidden");
            else totalsTaxesLabelTag.remove();

            const totalsShippingTextTag = dispatchDom.querySelector("totalsshippingtext");
            if (dispatch.totals.shippingText !== "checkout.product-info.dispatches.shipping-total-title") totalsShippingTextTag.outerHTML = dispatch.totals.shippingText || "";
            else totalsShippingTextTag.parentElement.remove();

            const totalsShippingValueTag = dispatchDom.querySelector("totalsshippingvalue");
            const totalsShippingLabelTag = dispatchDom.querySelector("totalsshippinglabel");
            if (dispatch.totals.shippingValue > 0) {
                totalsShippingValueTag.outerHTML = this.formatPrice(dispatch.totals.shippingValue, config.countries[window.snakeCheckout.currentCountry].currencySymbol, responseData.head.currencyIconPosition, responseData.head.currencyDecimalDivider);

                totalsShippingLabelTag.parentElement.remove();
            } else {
                totalsShippingLabelTag.outerHTML = dispatch.totals.shippingLabel || "";

                totalsShippingValueTag.parentElement.remove();
            }

            const totalsPremiumTextTag = dispatchDom.querySelector("totalspremiumtext");
            if (product.edition === "PR") {
                if (dispatch.totals.premiumText !== "checkout.product-info.dispatches.premium-total-title") totalsPremiumTextTag.outerHTML = dispatch.totals.premiumText || "";
                else totalsPremiumTextTag.parentElement.remove();

                const totalsPremiumValueTag = dispatchDom.querySelector("totalspremiumvalue");
                const totalsPremiumLabelTag = dispatchDom.querySelector("totalspremiumlabel");
                if (dispatch.totals.premiumValue) {
                    totalsPremiumValueTag.outerHTML = this.formatPrice(dispatch.totals.premiumValue || 0, config.countries[window.snakeCheckout.currentCountry].currencySymbol, responseData.head.currencyIconPosition, responseData.head.currencyDecimalDivider);

                    totalsPremiumLabelTag.parentElement.remove();
                } else {
                    if (dispatch.totals.premiumLabel !== "checkout.product-info.dispatches.premium-total-label") totalsPremiumLabelTag.outerHTML = dispatch.totals.premiumLabel || "";
                    else totalsPremiumLabelTag.parentElement.remove();

                    totalsPremiumValueTag.parentElement.remove();
                }
            } else totalsPremiumTextTag.parentElement.parentElement.remove();

            const totalsPriceTextTag = dispatchDom.querySelector("totalspricetext");
            if (dispatch.totals.priceText !== "checkout.product-info.dispatches.price-total-title") totalsPriceTextTag.outerHTML = dispatch.totals.priceText || "";
            else totalsPriceTextTag.parentElement.remove();

            const totalsPriceValueTag = dispatchDom.querySelector("totalspricevalue");
            if (dispatch.totals.priceValue > 0) totalsPriceValueTag.outerHTML = this.formatPrice(dispatch.totals.priceValue, config.countries[window.snakeCheckout.currentCountry].currencySymbol, responseData.head.currencyIconPosition, responseData.head.currencyDecimalDivider);
            else totalsPriceValueTag.parentElement.remove();
        }

        /**
         * DTS-3435
         * Remove issues, totals and taxes informations from the Next Shipment dispatch box if the flag showNextShipmentNote is active
         */
        if (dispatch.showNextShipmentNote) {
            const issues = document.querySelectorAll(".issue");
            if (issues.length) issues[issues.length - 1].remove();

            const totals = document.querySelectorAll(".totals");
            if (totals.length) totals[totals.length - 1].remove();

            const taxes = document.querySelectorAll(".taxes");
            if (taxes.length) taxes[taxes.length - 1].remove();
        }

        dispatchesDom.innerLoader(false);
    };

    static #renderIssue = (responseData, dispatch, dispatchDom, issue) => {
        const product = window.snakeCheckout.initData.products[0];
        const dispatchIssueDom = dispatchDom.querySelector(":scope .issue");

        dispatchIssueDom.appendChild(this.#componentDom.querySelector("template#tpl-issue").content.cloneNode(true));

        const issueDom = dispatchIssueDom.lastElementChild;

        let issueTitle = "";
        if (issue.nextShipmentIssueName) issueTitle = issue.nextShipmentIssueName;
        else if (["12", "FK"].includes(product.plan)) issueTitle = issue.description || "";
        else issueTitle = issue.name;
        issueDom.querySelector("issuetitle").outerHTML = issueTitle;

        const issueSalesPromoTag = issueDom.querySelector("issuesalespromo");
        if (issue.nextShipmentSalesPromo || issue.salesPromo) issueSalesPromoTag.outerHTML = issue.nextShipmentSalesPromo || issue.salesPromo || "";
        else issueSalesPromoTag.parentElement.remove();

        const issueOriginalPrice = issue.originalPrice || 0;
        const issueOriginalPriceTag = issueDom.querySelector("issueoriginalprice");
        if (issueOriginalPrice !== 0 && !dispatch.hideStrikethrough) {
            issue.originalPrice = this.formatPrice(issueOriginalPrice, config.countries[window.snakeCheckout.currentCountry].currencySymbol, responseData.head.currencyIconPosition, responseData.head.currencyDecimalDivider);

            issueOriginalPriceTag.outerHTML = issue.originalPrice;
        } else issueOriginalPriceTag.parentElement.remove();

        const issueSalesPriceTag = issueDom.querySelector("issuesalesprice");
        issue.salesPrice = this.formatPrice(issue.salesPrice || 0, config.countries[window.snakeCheckout.currentCountry].currencySymbol, responseData.head.currencyIconPosition, responseData.head.currencyDecimalDivider);
        issueSalesPriceTag.outerHTML = issue.salesPrice;
    };

    static #renderGifts = (responseData) => {
        const product = window.snakeCheckout.initData.products[0];
        const gifts = responseData.dispatches.slice(-1)[0]?.gifts || [];
        const standardGifts = gifts.filter((el) => !el.isPremium);
        const premiumGifts = product.edition === "PR" ? gifts.filter((el) => el.isPremium) : [];
        const standardGiftsWrapper = this.#componentDom.querySelector("#standard-gifts");

        if (standardGifts.length) {
            standardGiftsWrapper.querySelector("standardgiftstitle").outerHTML = responseData.head.giftsList.title || "";

            standardGifts.forEach((gift) => {
                standardGiftsWrapper.querySelector(".swiper-wrapper").appendChild(this.#componentDom.querySelector("template#tpl-gift").content.cloneNode(true));

                const giftDom = standardGiftsWrapper.querySelector(".swiper-wrapper").lastElementChild;

                if (gift.uptitle) giftDom.querySelector("giftuptitle").outerHTML = gift.uptitle;
                else giftDom.querySelector("giftuptitle").parentElement.remove();

                giftDom.querySelector("img").src = gift.image.src || "";
                giftDom.querySelector("gifttitle").outerHTML = gift.title || "";
            });

            // eslint-disable-next-line no-unused-vars
            const standardSwiper = new Swiper("#standard-gifts .swiper", {
                slidesPerView: 2.75,
                spaceBetween: 8,
                modules: [Navigation],
                navigation: {
                    prevEl: ".prev",
                    nextEl: ".next",
                },
                on: {
                    navigationPrev: function () {
                        AnalyticsService.summaryArrows();
                    },
                    navigationNext: function () {
                        AnalyticsService.summaryArrows();
                    },
                },
            });

            standardGiftsWrapper.innerLoader(false);
            standardGiftsWrapper.querySelector(".nav").classList.remove("hidden");
        } else standardGiftsWrapper.remove();

        const premiumGiftsWrapper = this.#componentDom.querySelector("#premium-gifts");

        if (premiumGifts.length) {
            premiumGiftsWrapper.querySelector("premiumgiftstitle").outerHTML = responseData.head.giftsList.titlePremium || "";

            premiumGifts.forEach((gift) => {
                premiumGiftsWrapper.querySelector(".swiper-wrapper").appendChild(this.#componentDom.querySelector("template#tpl-gift").content.cloneNode(true));

                const giftDom = premiumGiftsWrapper.querySelector(".swiper-wrapper").lastElementChild;

                if (gift.uptitle) giftDom.querySelector("giftuptitle").outerHTML = gift.uptitle;
                else giftDom.querySelector("giftuptitle").parentElement.remove();

                giftDom.querySelector("img").src = gift.image.src || "";
                giftDom.querySelector("gifttitle").outerHTML = gift.title || "";
            });

            // eslint-disable-next-line no-unused-vars
            const premiumSwiper = new Swiper("#premium-gifts .swiper", {
                slidesPerView: 2.75,
                spaceBetween: 8,
                modules: [Navigation],
                navigation: {
                    prevEl: ".prev",
                    nextEl: ".next",
                },
                on: {
                    navigationPrev: function () {
                        AnalyticsService.summaryArrows(true);
                    },
                    navigationNext: function () {
                        AnalyticsService.summaryArrows(true);
                    },
                },
            });

            premiumGiftsWrapper.innerLoader(false);
            premiumGiftsWrapper.querySelector(".nav").classList.remove("hidden");
        } else premiumGiftsWrapper.remove();
    };

    static #renderCheckoutProductImage = () => {
        fetch(import.meta.env.CO_SNAKE_API_CACHED.replace("-test", "-qa") + "/api/v1/core/service/product/asset?country=" + window.snakeCheckout.currentCountry + "&code=" + window.snakeCheckout.initData.products[0].code + "&type=checkout")
            .then((response) => response.blob())
            .then((response) => {
                const imgTag = this.#componentDom.querySelector("#product-image");

                if (response.size === 0) {
                    imgTag.nextElementSibling.classList.remove("absolute");
                    imgTag.nextElementSibling.classList.add("text-primary");
                } else imgTag.src = URL.createObjectURL(response);

                imgTag.parentElement.innerLoader(false);
            })
            .catch((e) => {
                AnalyticsService.errorEvent("0_init", "technical", "snakeAPI | summary get product image error", e);
            });
    };

    static formatPrice = (price, symbol, symbolPosition, separator) => {
        const formattedPrice = new Intl.NumberFormat(config.countries[window.snakeCheckout.currentCountry].lang || window.snakeCheckout.currentCountry + "-" + window.snakeCheckout.currentCountry.toUpperCase(), {
            // minimumFractionDigits: window.snakeCheckout.currentCountry?.toUpperCase() === "CZ" ? 0 : 2,
            // maximumFractionDigits: window.snakeCheckout.currentCountry?.toUpperCase() === "CZ" ? 0 : 2,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(price);

        // if (separator === "comma") formattedPrice = formattedPrice.replace(".", ",");
        // if (separator === "dot") formattedPrice = formattedPrice.replace(",", ".");
        if (symbolPosition === "before") return symbol + formattedPrice;
        if (symbolPosition === "after") return formattedPrice + " " + symbol;
    };

    // FR-2434
    static showReducedVersion = (cmpRefId) => {
        const isCountrySpecific = this.getCountryConfigReducedVersion();
        const isShow = isCountrySpecific ? cmpRefId >= 3 : cmpRefId >= 0;

        document.querySelectorAll(".sh-trigger").forEach((el) => {
            el.classList.toggle("hidden", !isShow);
        });
    };

    // FR-2434
    static getCountryConfigReducedVersion = () => {
        const countriesWithHigherCmpRef = ["fr", "es"];
        const currentCountry = window.snakeCheckout.currentCountry.toLowerCase();

        return countriesWithHigherCmpRef.includes(currentCountry);
    };
}
